import fileSys from "../../fileoprators/fileSystem";
import SettingsOprator from "../settingsoprator";
import { MAPDRAWPARAMS } from "../consts";
const DEFAULTSET = MAPDRAWPARAMS;
class MapDraw extends SettingsOprator {
  constructor() {
    super(fileSys.getTopographyCfgPath("mapDrawSettings.json"), DEFAULTSET);
  }
  getMapDrawSettings() {
    let settings = this.getSettings();
    if (settings.keratoconus) {
      settings.keratoconus.mapInForm0.mapIndexUI = 3;
      settings.keratoconus.mapInForm1.mapIndexUI = 5;
    }
    return settings;
  }
  saveMapDrawSettings(settings) {
    this.saveSettings(settings);
  }
}
export default MapDraw;



// WEBPACK FOOTER //
// ./src/settings/topography/mapDraw.js